module.exports = __webpack_public_path__ + "img/Summary_mobility_studies_frontcover.138332c2.jpg";